import SearchFilterSection from '@components/searchFilterSection/SearchFilterSection'
import { AssetsModule } from '@core/modules/digital-footprint/assets'
import { useUnifiedFilter } from '@core/hooks/useUnifiedFilter'
import { unifiedUsersFilterModule } from '../../users.filters'
import { FC, useMemo } from 'react'

const UsersHeader: FC = () => {
    const { data: allAssets } = AssetsModule.useStore()

    const userAssets = useMemo(
        () => allAssets.filter((a) => a.asset_type === 'user'),
        [allAssets]
    )

    const {
        search,
        filterConfig,
        data: filteredUsers,
        handleFilterChange,
        handleSearchChange,
        handleFilterReset,
        getFilterOptions,
        activeFilters,
    } = useUnifiedFilter({
        filterModule: unifiedUsersFilterModule,
        data: userAssets,
    })

    return (
        <SearchFilterSection
            allItems={userAssets}
            filteredItems={filteredUsers}
            onSearchChange={handleSearchChange}
            onFilterChange={handleFilterChange}
            getFilterOptions={getFilterOptions}
            filterConfig={filterConfig}
            searchValue={search}
            activeFilters={activeFilters}
            searchPlaceholder="Search users..."
            itemLabel="users"
            onFilterReset={handleFilterReset}
        />
    )
}

export default UsersHeader
